import { render, staticRenderFns } from "./CalendarEvent.vue?vue&type=template&id=9f9791d6&scoped=true"
import script from "./CalendarEvent.vue?vue&type=script&lang=js"
export * from "./CalendarEvent.vue?vue&type=script&lang=js"
import style0 from "./CalendarEvent.vue?vue&type=style&index=0&id=9f9791d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9791d6",
  null
  
)

export default component.exports